import '../../styles/blocks/_promo-code.scss';
import './promotionalCode.scss';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { history } from 'routes/history';
import { InputText } from 'components/inputText/inputText';
import Accordion from 'components/commons/accordion/accordion';
import AccordionBody from 'components/commons/accordion/accordionBody/accordionBody';
import validator from 'validator';
import { FormattedText, formatText, getLanguage } from 'core/i18n';
import { CHECKING_ACCOUNT, OPEN_DEBIT } from 'constants/precontractual';
import { OPEN_CREDIT, VALUES_ACCOUNT, FUNDS, PLANS, PORTFOLIO } from 'constants/products';
import { PATH_OPEN_YOUR_ACCOUNT } from 'constants/uTagConstants/paths';
import { ROBO_PATH } from 'constants/pathInvestments';
import { ROBO as ROBO_FLAG } from 'constants/featureFlagging';
import { BASE_PATH } from 'constants/index';
import { KEY_ENTER } from 'constants/keycode';
import iconComplementaryLink from 'assets/icons/arrow-complementary_link.svg';
import { TRADITIONAL, ROBO, GBI } from 'constants/userProfile';
import { isMobile } from 'utilities/browser';
import {
    doTagAccordionClick,
    doTagClickOkButtonPromo,
    doTagErrorPromoCode,
    doTagFocusPromoInputText,
    doTagHandleOnRemoveCode,
    doTagHandleSeeConditionsLinkClick,
    doTagValidPromoCode,
} from 'components/promotionalCode/tagging';

export class PromotionalCode extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            buttonDisabled: true,
            showModal: false,
            blowUpFade: 'blowup-in',
            promoErrorMsg: '',
        };

        this.validateCode = this.validateCode.bind(this);
        this.handleOnRemoveCode = this.handleOnRemoveCode.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.buildPromoDetails = this.buildPromoDetails.bind(this);
        this.buildRender = this.buildRender.bind(this);
        this.handleOnToggleModal = this.handleOnToggleModal.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { formActions, defaultPromoCode } = this.props;
        if (typeof defaultPromoCode !== 'undefined' && defaultPromoCode != null) {
            formActions.change('userProfile.promoCode', defaultPromoCode);
            this.validateCode();
        }
    }

    handleSeeConditionsLinkClick = event => {
        event.preventDefault();
        const { products, promoCode } = this.props;
        const promotionalCode = promoCode.get('promotionalCode');
        const url = promotionalCode.get('url');
        doTagHandleSeeConditionsLinkClick(products);
        window.open(url, '_blank').focus();
    };

    validateCode() {
        const {
            userProfile,
            formActions,
            isValid,
            isNotValid,
            promotionalCodeAction,
            defaultPromoCode,
            productsActions,
        } = this.props;
        const code = defaultPromoCode != null ? defaultPromoCode : userProfile.promoCode;
        const language = getLanguage();

        if (code) {
            this.setState({
                loading: true,
            });

            promotionalCodeAction.getPromotion(code, language, (valid, error) => {
                this.setState({
                    loading: false,
                });
                if (valid) {
                    const { flags, promoCode, products, preLoaderActions } = this.props;
                    const promoCodeInfo = promoCode.get('promotionalCode');
                    const productsInfo = products.get('products');
                    if (promoCodeInfo.get('status') === 'OK') {
                        if (isValid) {
                            if (defaultPromoCode) {
                                if (
                                    promoCodeInfo.get('isRoboPromoCode') &&
                                    flags.get(ROBO_FLAG) &&
                                    userProfile.investmentType !== ROBO
                                ) {
                                    formActions.change('userProfile.urlChange', true);
                                    formActions.change('userProfile.investmentType', ROBO);
                                    history.push(`${BASE_PATH}/${ROBO_PATH}`);
                                }
                            }
                            if (code.toLowerCase() === 'tarjetahome') {
                                formActions.change('userProfile.withConfigCard', true);
                            }

                            productsInfo.forEach(value => {
                                if (value.description.includes(OPEN_CREDIT)) {
                                    formActions.change('userProfile.openCredit', true);
                                } else if (value.description.includes(VALUES_ACCOUNT)) {
                                    formActions.change('userProfile.valuesAccount', true);
                                }
                            });

                            formActions.resetValidity('userProfile.promoCode');

                            doTagValidPromoCode({ userProfile, products, code });

                            preLoaderActions.hidePreLoader();
                            if (userProfile.investmentType === TRADITIONAL) {
                                if (promoCodeInfo.get('isRoboPromoCode') && flags.get(ROBO_FLAG)) {
                                    this.setState({
                                        showModal: true,
                                    });
                                }
                            }
                            if (this.props.promoCode.get('roboPromoCodeError')) {
                                formActions.setErrors('userProfile.promoCode', '');

                                return false;
                            }
                        }

                        return true;
                    }
                    const expired = promoCode.get('expired');
                    let customErrorDescription;
                    if (expired) {
                        formActions.setErrors('userProfile.promoCode', formatText('validation-promoCodeExpired'));
                        customErrorDescription = formatText('validation-promoCodeExpired');
                    } else {
                        formActions.setErrors('userProfile.promoCode', formatText('validation-promoCodeInvalid'));
                        customErrorDescription = 'ERROR EN CONSULTAR CODIGO PROMOCIONALES';
                    }
                    doTagErrorPromoCode({ error, customErrorDescription });

                    if (isNotValid) {
                        productsActions.clearProductsInfo();
                        productsActions.getProducts();
                        isNotValid();
                    }

                    return false;
                }
                const { promoCode } = this.props;
                const expired = promoCode.get('expired');
                let customErrorDescription;

                if (expired) {
                    formActions.setErrors('userProfile.promoCode', formatText('validation-promoCodeExpired'));
                    customErrorDescription = formatText('validation-promoCodeExpired');
                } else {
                    formActions.setErrors('userProfile.promoCode', formatText('validation-promoCodeInvalid'));
                    customErrorDescription = 'ERROR EN CONSULTAR CODIGO PROMOCIONALES';
                }
                doTagErrorPromoCode({ error, customErrorDescription });

                if (isNotValid) {
                    if ([FUNDS, PLANS, PORTFOLIO].includes(code.toLowerCase())) {
                        formActions.change('userProfile.promoCode', '');
                        formActions.reset('userProfile.promoCode');
                        formActions.resetValidity('userProfile.promoCode');
                    }
                    productsActions.clearProductsInfo();
                    productsActions.getProducts();
                    isNotValid();
                }

                return false;
            });
        } else {
            formActions.setErrors('userProfile.promoCode', formatText('validation-promoCodeInvalid'));

            if (isNotValid) {
                if ([FUNDS, PLANS, PORTFOLIO].includes(code.toLowerCase())) {
                    formActions.change('userProfile.promoCode', '');
                    formActions.reset('userProfile.promoCode');
                    formActions.resetValidity('userProfile.promoCode');
                }
                productsActions.clearProductsInfo();
                productsActions.getProducts();
                isNotValid();
            }

            return false;
        }
    }

    handleOnRemoveCode() {
        const { products, formActions, isValid, productsActions, promotionalCodeAction, userProfile } = this.props;

        const language = getLanguage();
        formActions.change('userProfile.promoCode', '');
        formActions.reset('userProfile.promoCode');
        formActions.change('userProfile.withConfigCard', false);
        formActions.change('userProfile.openCredit', false);
        promotionalCodeAction.clearPromotion();
        productsActions.clearProductsInfo();
        productsActions.getProducts();
        productsActions.getCreditCardOffer(userProfile.creditCardOffer_accepted, '', language);

        if (isValid) {
            isValid([CHECKING_ACCOUNT, OPEN_DEBIT]);
        }
        this.setState({
            buttonDisabled: true,
        });
        doTagHandleOnRemoveCode(products);
    }

    handleOnChange(event) {
        const { formActions, promoCode, promotionalCodeAction } = this.props;
        const promoCodeRoboError = promoCode.get('roboPromoCodeError');
        const val = event.target.value;
        if (promoCodeRoboError) {
            formActions.resetValidity('userProfile.promoCode');
            promotionalCodeAction.resetPromoCodeErrorRobo();
        }
        this.setState({
            buttonDisabled: val.length === 0,
        });
    }

    buildPromoDetails() {
        const { userProfile } = this.props;
        const promoCode = this.props.promoCode.get('promotionalCode');
        const classPromoCode =
            typeof this.props.class !== 'undefined' ? `promo-code__details ${this.props.class}` : 'promo-code__details';
        const removeCodeButton =
            this.props.defaultPromoCode == null && this.props.class !== 'promo-code__details--top' ? (
                <div className="cancel-buton" onClick={this.handleOnRemoveCode}>
                    <i className="cancel-buton--icon icons icons--icon-cancel"></i>{' '}
                </div>
            ) : null;
        const cleanImage = isMobile();
        const subTitleClass = 'promo-code__details-subtitle';
        if (promoCode.size && promoCode.get('status') === 'OK') {
            const title = promoCode.get('title');
            const details = promoCode.get('details');
            const img = promoCode.get('img');
            const url = promoCode.get('url');
            const imageTitle = (
                <div className={`col-xs-12 col-sm-4 ${!img ? 'hidden' : ''}`}>
                    <img className="img-responsive" src={img} />
                </div>
            );

            const promoTitle = url ? formatText('promoCode-appliedGift') : formatText('promoCode-selectProduct');
            const urlChange = userProfile.urlChange;
            const removeButton = urlChange ? null : removeCodeButton;
            const isProductCode = this.props.userProfile.product;

            return (
                <div className={classPromoCode}>
                    <div className="row">
                        <div className="col-md-12 promo-code-title">
                            {!isProductCode && (
                                <>
                                    <div className="font-heading3">{promoTitle}</div>
                                    <span className="dash"></span>
                                </>
                            )}
                            {removeButton}
                        </div>
                    </div>
                    <div className="row">
                        {imageTitle}
                        <div className="col-xs-12 col-sm-8">
                            <h5 className={subTitleClass}>{title}</h5>
                            <p className={`promo-code__details-description ${cleanImage ? 'margin-description' : ''}`}>
                                {details}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-4" />
                        {url && !isProductCode && (
                            <div className="col-xs-12 col-sm-8">
                                <a
                                    href="#"
                                    onClick={this.handleSeeConditionsLinkClick}
                                    target="_blank"
                                    className="promo-code__details-link"
                                    rel="noreferrer"
                                >
                                    <span>
                                        <FormattedText value="promoCode-seeConditions" />
                                    </span>
                                    <img height="10" width="10" src={iconComplementaryLink} />
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return null;
    }

    handleRedirect() {
        const { userProfile, formActions } = this.props;
        if (userProfile.investmentType === ROBO || userProfile.investmentType === GBI) {
            formActions.resetValidity('userProfile.promoCode');
            formActions.change('userProfile.urlChange', true);
            formActions.change('userProfile.investmentType', TRADITIONAL);
            history.push(`${BASE_PATH}/`);
            window.scrollTo(0, 0);
        }
    }

    handlePromoKeyUp = event => {
        event.preventDefault();
        event.which === KEY_ENTER && this.validateCode();
    };

    buildRender() {
        const { userProfile, userProfileForm, formActions } = this.props;
        const promoCode = this.props.promoCode.get('promotionalCode');
        const validateCode = this.validateCode;
        let validCode = false;
        let disableInput = false;
        let entries = 0;
        let promoCodeError = null;
        const promoCodeRoboError = this.props.promoCode.get('roboPromoCodeError');
        promoCodeError = promoCodeRoboError ? (
            <a
                href="#"
                className="promo-code-link-error"
                onClick={event => {
                    event.preventDefault();
                    this.handleRedirect();
                }}
            >
                {formatText('promoCode-errorLink')}
            </a>
        ) : null;

        if (promoCode.get('status') === 'OK' && !this.props.promoCode.get('roboPromoCodeError')) {
            disableInput = true;
            entries++;
            validCode = true;
        }

        let bottonClass = !validCode || entries === 0 ? 'form__button form__button-primaryB promo-code__ok' : 'hidden';
        const iconClass = validCode ? 'promo-code__icon-ok' : 'hidden';
        bottonClass += this.state.buttonDisabled ? ' form__button-primary--disabled' : '';

        let buttonContent = formatText('button-ok');
        if (this.state.loading) {
            disableInput = true;
            bottonClass += ' form__button-primary--disabled';
            buttonContent = (
                <div className="icons icons--icon-loader" title="2">
                    <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="20px"
                        height="20px"
                        viewBox="0 0 50 50"
                    >
                        <path
                            fill="#000"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                        >
                            <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="rotate"
                                from="0 25 25"
                                to="360 25 25"
                                dur="0.6s"
                                repeatCount="indefinite"
                            />
                        </path>
                    </svg>
                </div>
            );
        }

        const inputClass = this.props.promoCode.get('roboPromoCodeError') ? 'inputError' : null;
        const msgError = this.props.promoCode.get('roboPromoCodeError') ? formatText('promoCode-promoCodeError') : null;

        return (
            <div>
                <div className="promo-code">
                    <div id="promoCodeContainer" className="promo-code__input row">
                        <div className="col-xs-9 col-sm-6">
                            <InputText
                                profileModel={'userProfile.promoCode'}
                                id="promocode"
                                type="text"
                                inputClass={inputClass}
                                placeholder={formatText('promotionalCode-placeholder')}
                                disabled={disableInput}
                                validations={{
                                    valid: value => {
                                        return value !== '' && validator.matches(value, /^[a-zA-Z0-9\-_ñÑ&]+$/);
                                    },
                                }}
                                messagesError={{
                                    valid: formatText('validation-promoCodeInvalid'),
                                    correct: formatText('validation-promoCodeInvalid'),
                                }}
                                onChange={this.handleOnChange}
                                userProfile={userProfile}
                                formActions={formActions}
                                userProfileForm={userProfileForm}
                                onKeyUp={this.handlePromoKeyUp}
                                onFocus={doTagFocusPromoInputText}
                            />
                            <p className="msgError">
                                {msgError} {promoCodeError}
                            </p>
                        </div>

                        <div className="col-xs-3 col-sm-4 form__input-button">
                            <label>&nbsp;</label>
                            <div>
                                <a
                                    href="#"
                                    className={bottonClass}
                                    onClick={event => {
                                        event.preventDefault();
                                        doTagClickOkButtonPromo();
                                        validateCode();
                                    }}
                                >
                                    {buttonContent}
                                </a>
                                <span className={iconClass}></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleContinue = () => {
        const { userProfile, formActions } = this.props;
        this.setState({
            showModal: false,
        });

        if (userProfile.investmentType === TRADITIONAL) {
            formActions.change('userProfile.urlChange', true);
            formActions.change('userProfile.investmentType', ROBO);
            history.push(`${BASE_PATH}/${ROBO_PATH}`);
            window.scrollTo(0, 0);
        }
    };

    buildButtons = () => {
        return (
            <div className="options-area">
                <button className="form__button form__button-clean" type="button" onClick={this.handleOnToggleModal}>
                    <span className="cancelPromo">{formatText('button-cancel')}</span>
                </button>
                <button className="form__button form__button-secondary" type="button" onClick={this.handleContinue}>
                    {<FormattedText value="button-continue" />}
                </button>
            </div>
        );
    };

    buildModalBody() {
        const promoCode = this.props.promoCode.get('promotionalCode');
        const classPromoCode =
            typeof this.props.class !== 'undefined'
                ? `promo-code__details__modal ${this.props.class}`
                : 'promo-code__details__modal';
        const cleanImage = isMobile();
        const subTitleClass = cleanImage ? 'promo-code__details-subtitle-mobile' : 'promo-code__details-subtitle';
        if (promoCode.size && promoCode.get('status') === 'OK') {
            const title = promoCode.get('title');
            const details = promoCode.get('details');
            const img = promoCode.get('img');
            const url = promoCode.get('url');
            const imageTitle = cleanImage ? (
                <div
                    className={`col-xs-12 col-sm-4 image-mobile ${!img ? 'hidden' : ''}`}
                    style={{ backgroundImage: `url(${img})` }}
                />
            ) : (
                <div className={`col-xs-12 col-sm-4 ${!img ? 'hidden' : ''}`}>
                    <img className="img-responsive" src={img} />
                </div>
            );
            const promoTitle = url ? formatText('promoCode-appliedGift') : formatText('promoCode-selectProduct');

            return (
                <div className={classPromoCode}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="font-heading3">{promoTitle}</div>
                            <span className="dash"></span>
                        </div>
                    </div>
                    <div className="row">
                        {imageTitle}
                        <div className="col-xs-12 col-sm-8">
                            <h5 className={subTitleClass}>{title}</h5>
                            <p className={`promo-code__details-description ${cleanImage ? 'margin-description' : ''}`}>
                                {details}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-4" />
                        {url && (
                            <div className="col-xs-12 col-sm-8">
                                <a
                                    href="#"
                                    onClick={this.handleSeeConditionsLinkClick}
                                    target="_blank"
                                    className="promo-code__details-link"
                                    rel="noreferrer"
                                >
                                    <span>
                                        <FormattedText value="promoCode-seeConditions" />
                                    </span>
                                    <img height="10" width="10" src={iconComplementaryLink} />
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return null;
    }

    handleOnToggleModal() {
        if (this.state.showModal) {
            this.setState({ blowUpFade: 'blowup-out' });
            setTimeout(() => {
                this.setState({
                    showModal: false,
                    blowUpFade: 'blowup-in',
                });
            }, 250);
            this.handleOnRemoveCode();
        } else {
            this.setState({ showModal: true });
        }
    }

    render() {
        const { promoCode, userProfile } = this.props;
        const statusPromoCode = promoCode.get('promotionalCode');
        const promoCodeClass = 'promo-code';
        const promoCodeCustomClass = 'collapsing-toggle-promo-code';
        const promoCodeTitleClass = 'accordion-title-promo-code';
        const buildRender = this.buildRender();
        const buildPromoDetails = this.buildPromoDetails();
        const buttons = this.buildButtons();
        const buildModalBody = this.buildModalBody();
        let promoCodeSection;
        const classAccordion = [ROBO, GBI].includes(userProfile.investmentType) ? 'accordion-robo' : null;
        const line = [ROBO, GBI].includes(userProfile.investmentType) ? null : <hr />;

        const promoCodeAccordion = (
            <div className={classAccordion}>
                {line}
                <Accordion
                    id="promoCode"
                    customClassName={promoCodeClass}
                    customTitleClassName={promoCodeTitleClass}
                    customToggleClassName={promoCodeCustomClass}
                    title={<FormattedText value="promoCode-DoYouHavePromoCode" />}
                    expandable={true}
                    isExpanded={true}
                    recordEvent={doTagAccordionClick}
                >
                    <AccordionBody name="AccordionBody">{buildRender}</AccordionBody>
                </Accordion>
            </div>
        );

        if (
            this.props.defaultPromoCode == null ||
            ![FUNDS, PLANS, PORTFOLIO].includes(this.props.defaultPromoCode.toLowerCase())
        ) {
            promoCodeSection = promoCodeAccordion;

            if (userProfile.investmentType === TRADITIONAL) {
                if (
                    statusPromoCode.get('status') === 'OK' &&
                    (!promoCode.get('roboPromoCodeError') || userProfile.urlChange)
                ) {
                    promoCodeSection = buildPromoDetails;
                }
            }

            if (userProfile.investmentType === ROBO) {
                if (
                    statusPromoCode.get('status') === 'OK' &&
                    (!promoCode.get('roboPromoCodeError') || userProfile.urlChange)
                ) {
                    promoCodeSection = buildPromoDetails;
                }
            }
        } else {
            promoCodeSection = buildPromoDetails;
        }

        const modalSubtitule = statusPromoCode.get('isRoboPromoCode')
            ? formatText('promoCode-roboModal')
            : formatText('promoCode-traditionalModal');

        return (
            <div>
                {promoCodeSection}
                <Modal
                    show={this.state.showModal}
                    backdrop="static"
                    dialogClassName={`blowup-modal ${this.state.blowUpFade}`}
                >
                    <Modal.Header>
                        <div className="close-icon">
                            <a
                                href="#"
                                onClick={event => {
                                    event.preventDefault();
                                    this.handleOnToggleModal();
                                }}
                            >
                                <span className="icons--icon-cancel"></span>
                            </a>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {buildModalBody}
                        <label className="promo-subtitule">{modalSubtitule}</label>
                        <hr />
                    </Modal.Body>
                    <Modal.Footer>
                        {buttons}
                        <div className="clearfix"></div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
